import React from "react";

const FilteringIcon = () => {
  return (
    <svg width="24px" height="21px" viewBox="0 0 24 21">
      <g
        id="new-checkmarks"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-82.000000, -252.000000)"
          fill="#231F20"
        >
          <g
            id="filtering-icon-copy-2"
            transform="translate(82.000000, 252.000000)"
          >
            <rect
              id="bottom-bar"
              x="0"
              y="15.75"
              width="23.4"
              height="2.7"
              rx="1.35"
            ></rect>
            <rect
              id="middle-bar"
              x="0"
              y="9"
              width="23.4"
              height="2.7"
              rx="1.35"
            ></rect>
            <rect
              id="top-bar"
              x="0"
              y="2.25"
              width="23.4"
              height="2.7"
              rx="1.35"
            ></rect>
            <circle id="outer-circle" cx="5.85" cy="3.6" r="3.15"></circle>
            <circle id="outer-circle" cx="16.65" cy="10.35" r="3.15"></circle>
            <circle id="outer-circle" cx="8.55" cy="17.1" r="3.15"></circle>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FilteringIcon;
